import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Navbar from "../navigation";
import NavigationBar from "../talent/NavigationTalent";
import AdminNavbar from "../admin/AdminNav";
import Footer from "../Footer";
import { useQuestionsApi } from "../admin/components/useQuestions";
import "../styles/richText.css";
import DOMPurify from "dompurify";
import PublicNavbar from "../RootNavigation";

export default function QuestionsPage() {
  const userRole = localStorage.getItem("userRole");
  const { getQuestions, getCategories } = useQuestionsApi();

  const [groupedQuestions, setGroupedQuestions] = useState({});
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  // ================= FETCH & GROUP =================
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [questions, categoryData] = await Promise.all([
          getQuestions(),
          getCategories(),
        ]);

        //  SORT QUESTIONS
        const sortedQuestions = [...(questions || [])].sort(
          (a, b) => (a.position || 0) - (b.position || 0),
        );

        //  GROUP BY CATEGORY
        const grouped = sortedQuestions.reduce((acc, q) => {
          const categoryName = q.category || "General";

          if (!acc[categoryName]) acc[categoryName] = [];
          acc[categoryName].push(q);

          return acc;
        }, {});

        setGroupedQuestions(grouped);
        setCategories(categoryData || []);

        //  SET DEFAULT CATEGORY BASED ON CATEGORY POSITION
        const sortedCategoryNames = [...(categoryData || [])]
          .sort((a, b) => (a.position || 0) - (b.position || 0))
          .map((c) => c.questionName);

        if (sortedCategoryNames.length > 0) {
          setSelectedCategory(sortedCategoryNames[0]);
        }
      } catch (error) {
        console.error("Failed to load questions", error);
      }
    };

    fetchData();
  }, []);
function decodeHtml(html) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}
  //  SORT CATEGORIES FROM BACKEND POSITION
  const sortedCategories = [...categories]
    .sort((a, b) => (a.position || 0) - (b.position || 0))
    .map((c) => c.questionName);

  return (
    <>
      {/* NAVBAR */}
      {userRole === "ADMIN" ? (
        <AdminNavbar />
      ) : userRole === "COMPANY" ? (
        <Navbar />
      ) : userRole === "USER" ? (
        <NavigationBar />
      ):(
        <PublicNavbar />
      )}

      {/* MAIN */}
      <Box sx={{ background: "#eeeeee", py: 3 }}>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Typography variant="h4" gutterBottom>
            Frequently Asked Questions
          </Typography>

          <Grid container spacing={3}>
            {/* ================= LEFT: CATEGORIES ================= */}
            <Grid item xs={12} md={3}>
              <Paper sx={{ p: 1 }}>
                <List>
                  {sortedCategories.map((category) => (
                    <ListItemButton
                      key={category}
                      selected={selectedCategory === category}
                      onClick={() => setSelectedCategory(category)}
                      sx={{
                        borderRadius: 2,
                        mb: 0.5,

                        "&:hover": {
                          backgroundColor: "#e3ecff",
                        },

                        "&.Mui-selected": {
                          backgroundColor: "#90b5fe",
                          color: "#000",
                          fontWeight: 600,
                        },

                        "&.Mui-selected:hover": {
                          backgroundColor: "#7aa5fd",
                        },
                      }}
                    >
                      <ListItemText primary={category} />
                    </ListItemButton>
                  ))}
                </List>
              </Paper>
            </Grid>

            {/* ================= RIGHT: QUESTIONS ================= */}
            <Grid item xs={12} md={9}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="h6" gutterBottom>
                  {selectedCategory}
                </Typography>

                {groupedQuestions[selectedCategory]?.length > 0 ? (
                  groupedQuestions[selectedCategory].map((q) => (
                    <Accordion key={q.questionId}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography fontWeight="bold">
                          {q.questionText}
                        </Typography>
                      </AccordionSummary>

                      {/*  UPDATED PART */}
                     <AccordionDetails>
<Typography
  className="rich-text"
  component="div"
  dangerouslySetInnerHTML={{
    __html: DOMPurify.sanitize(
      decodeHtml(q.answerText)
    ),
  }}
/>
</AccordionDetails>
                    </Accordion>
                  ))
                ) : (
                  <Typography>No questions available</Typography>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Footer />
    </>
  );
}